import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: true,
    imports: [MatButtonModule]
})
export class PageNotFoundComponent {

  private state: string = '';

  constructor(
    private readonly router: Router,
  ) {
  }

  mainPageButtonHandler() {
    const url = this.router.url.split('/');
    let redirectUrl = '';

    if (url.length > 1) {
      redirectUrl = url[0] + '/' + url[1]
    }
    this.router.navigate([redirectUrl]);
  }
}
